import { http } from "./http";
import { DOWNLOAD_DOCUMENT_URL, VALIDATE_MANUFACTURER_LINK } from "./URL";

export const downloadDocumentByDocumentId = async (ivrDocumentId: number) => {
  try {
    const response = await http.get(`${DOWNLOAD_DOCUMENT_URL}/${ivrDocumentId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const validateEmailLinkByToken = async (token: string) => {
  try {
    const response = await http.get(VALIDATE_MANUFACTURER_LINK, {
      params: {
        token
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};